/**
 * Display-only document name helper.
 *
 * Strips the storage hash suffix from stored filenames while keeping the
 * original extension intact.
 */
export function displayDocumentName(filename: string): string {
  const stripped = filename.replace(/-[0-9a-f]{16,}(?=\.[^.]+$|$)/i, "");
  // Guard the pathological case where the whole stem is a hash (e.g. "-<hex>.docx"),
  // which would collapse to a bare extension; fall back to the original name.
  return stripped && !stripped.startsWith(".") ? stripped : filename;
}
